
import { useState } from 'react';

function ClinicButton({
  clinicName,
  phone,
  position,
  color,
}: {
  clinicName: string;
  phone: string;
  position: 'left' | 'right';
  color: { from: string; to: string; shadow: string };
}) {
  const [isHovered, setIsHovered] = useState(false);
  const posClass = position === 'left' ? 'left-4 sm:left-6' : 'right-4 sm:right-6';

  return (
    <a
      href={`tel:${phone}`}
      className={`fixed bottom-4 sm:bottom-6 ${posClass} z-50 flex items-center gap-2 sm:gap-3 bg-gradient-to-r ${color.from} ${color.to} text-white rounded-full shadow-2xl ${color.shadow} transition-all duration-300 hover:scale-105 active:scale-95 cursor-pointer`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onTouchStart={() => {}}
      style={{ padding: isHovered ? '12px 20px' : '12px' }}
    >
      <div className="w-7 h-7 sm:w-8 sm:h-8 flex items-center justify-center">
        <i className="ri-phone-fill text-xl sm:text-2xl animate-pulse"></i>
      </div>

      {/* スマホでは常に表示 */}
      <div className="flex flex-col sm:hidden">
        <span className="text-[10px] font-medium leading-tight">{clinicName}</span>
        <span className="text-sm font-bold leading-tight">{phone}</span>
      </div>

      {/* PC版はホバーで表示 */}
      <div
        className={`hidden sm:block overflow-hidden transition-all duration-300 whitespace-nowrap ${
          isHovered ? 'max-w-xs opacity-100' : 'max-w-0 opacity-0'
        }`}
      >
        <div className="flex flex-col">
          <span className="text-xs font-medium">{clinicName}</span>
          <span className="text-lg font-bold">{phone}</span>
        </div>
      </div>
    </a>
  );
}

export default function FloatingCallButton() {
  return (
    <>
      <ClinicButton
        clinicName="LIOデンタルクリニック"
        phone="078-453-0828"
        position="left"
        color={{
          from: 'from-teal-500',
          to: 'to-emerald-600',
          shadow: 'hover:shadow-teal-500/50',
        }}
      />
      <ClinicButton
        clinicName="いくの歯科医院"
        phone="06-6777-6714"
        position="right"
        color={{
          from: 'from-amber-400',
          to: 'to-yellow-500',
          shadow: 'hover:shadow-amber-500/50',
        }}
      />
    </>
  );
}
